// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.check-class {\n  background-color: var(--surface-primary);\n  border: 1px solid var(--stroke-);\n  border-radius: 8px;\n  padding: 10px 10px 10px 10px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
